export default "__VITE_ASSET__D$vGUh$0__"